<script setup lang="ts">
  interface Props {
    loading: boolean;
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "update:loading", loading: boolean): void;
  }
  const emit = defineEmits<Emits>();
  const computedData = computed<boolean>({
    get: () => props.loading,
    set: value => {
      emit("update:loading", value);
    },
  });
</script>

<template>
  <v-overlay
    v-model="computedData"
    contained
    persistent
    scrim="black"
    data-testid="overlay"
  ></v-overlay>
</template>
